













































































import { cleanTask } from '@/api/property/cleanTask';
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue'
import { elevatorStatus, elevatorType, templateType } from '@/utils/enum/enum'
import { formatStampTime } from '@/utils/translateTime'

@Component({
  components: {
    Pagination
  }
})
export default class Table extends Vue {
  private batchData: any[] = []
  private cleanTasks: any = {}
  private dialogFormVisible: boolean = false
  private imgInfo: any = ''
  private fileList: any = []

  private OSS_THUMBNAIL: string = '?x-oss-process=image/resize,p_50'
  private OSS_WATERMARK: string = '/watermark,image_eGlhb3Rpd2F0ZXJtYXJrMi5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF81MA==,t_50,g_se,x_0,y_10'

  private created() {
    let cleanTaskId: number = Number(this.$route.query.cleanTaskId)
    this.showDetail(cleanTaskId)
  }

  private handleSelectionChange(val: any) {
    this.batchData = val
  }

  private showDetail(cleanTaskId: number) {
    cleanTask('GET', {}, null, `/${cleanTaskId}`).then((res: any) => {
      this.cleanTasks = res
    })
  }

  private showPic(imageUrls: any[]) {
    imageUrls.forEach(item => {
      item.url = item.url.indexOf('?') > 0 ? item.url : item.url + this.OSS_THUMBNAIL + this.OSS_WATERMARK
    })
    this.fileList = imageUrls
    this.dialogFormVisible = true
  }

  private formatStampTime(stampTime: number) {
    return formatStampTime(stampTime)
  }

  private rotateImg(index: number, url: string) {
    const arr = url.split('resize,p_50')
    let newurl = arr[0] + 'resize,p_50/rotate,90' + arr[1]
    this.fileList[index].url = newurl
  }

  private cleanImg() {
    this.fileList = []
  }

  private publish() {
    window.print()
  }
}
